import { ReactNode } from 'react'

interface StepCardProps {
	step: number
	icon: ReactNode
	title: string
	description: string
}

export function StepCard({ step, icon, title, description }: StepCardProps) {
	return (
		<div className='relative flex w-full flex-col overflow-hidden rounded-2xl border border-border bg-card'>
			<div className='relative flex h-[108px] flex-col items-center justify-center gap-2 overflow-hidden bg-background py-6'>
				<span className='pointer-events-none absolute h-24 w-64 -translate-y-2 rounded-full bg-gradient-to-r from-info to-primary opacity-60 blur-[60px]' />
				<span className='relative flex h-9 w-9 items-center justify-center text-primary'>{icon}</span>
				<span className='relative text-[11px] font-semibold uppercase tracking-[-0.015em] text-primary'>Step {step}</span>
			</div>

			<div className='flex flex-col items-center gap-4 px-6 py-6 text-center'>
				<h3 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>{title}</h3>
				<p className='text-base leading-[140%] tracking-[-0.24px] text-muted-foreground'>{description}</p>
			</div>
		</div>
	)
}
